/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feature_Animation_Triple_Coin_TitleInputs */

const en_feature_animation_triple_coin_title = /** @type {(inputs: Feature_Animation_Triple_Coin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every focus, <span style="@@">3x richer with Plus</span>`)
};

const ar_feature_animation_triple_coin_title = /** @type {(inputs: Feature_Animation_Triple_Coin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل جلسة تركيز، <span style="@@">أغنى بـ 3 أضعاف مع</span> Plus`)
};

const de_feature_animation_triple_coin_title = /** @type {(inputs: Feature_Animation_Triple_Coin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Fokus, <span style="@@">3x reicher mit Plus</span>`)
};

const es_feature_animation_triple_coin_title = /** @type {(inputs: Feature_Animation_Triple_Coin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada concentración, <span style="@@"> x3 veces más ganancias con Plus</span>`)
};

const fr_feature_animation_triple_coin_title = /** @type {(inputs: Feature_Animation_Triple_Coin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A chaque session, <span style="@@">3x plus de pièces avec Plus</span>`)
};

const it_feature_animation_triple_coin_title = /** @type {(inputs: Feature_Animation_Triple_Coin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ad ogni concentrazione, <span style="@@">ricompense x3 con Plus</span>`)
};

const ja_feature_animation_triple_coin_title = /** @type {(inputs: Feature_Animation_Triple_Coin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎日の集中で<span style="@@">Plusなら報酬が3倍</span>`)
};

const ko_feature_animation_triple_coin_title = /** @type {(inputs: Feature_Animation_Triple_Coin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중마다, <span style="@@">Plus 구독 시 3배 더 많은 보상 </span>`)
};

const pt_br_feature_animation_triple_coin_title = /** @type {(inputs: Feature_Animation_Triple_Coin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada foco, <span style="@@">3x maior com Plus</span>`)
};

const ru_feature_animation_triple_coin_title = /** @type {(inputs: Feature_Animation_Triple_Coin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`С каждой фокусировкой становитесь <span style="@@">в 3 раза богаче вместе с Plus</span>`)
};

const th_feature_animation_triple_coin_title = /** @type {(inputs: Feature_Animation_Triple_Coin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทุกการโฟกัส <span style="@@">ได้มากขึ้น 3 เท่าด้วย Plus</span>`)
};

const tr_feature_animation_triple_coin_title = /** @type {(inputs: Feature_Animation_Triple_Coin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her odaklanma, <span style="@@">Plus ile 3 kat daha zengin</span>`)
};

const zh_cn_feature_animation_triple_coin_title = /** @type {(inputs: Feature_Animation_Triple_Coin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一样专注，
<span style="@@">Plus 会员三倍富</span>`)
};

const zh_tw_feature_animation_triple_coin_title = /** @type {(inputs: Feature_Animation_Triple_Coin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同樣專注，
<span style="@@">Plus 給你三倍</span>`)
};

/**
* | output |
* | --- |
* | "Every focus, <span style=\"@@\">3x richer with Plus</span>" |
*
* @param {Feature_Animation_Triple_Coin_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const feature_animation_triple_coin_title = /** @type {((inputs?: Feature_Animation_Triple_Coin_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feature_Animation_Triple_Coin_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_feature_animation_triple_coin_title(inputs)
	if (locale === "ar") return ar_feature_animation_triple_coin_title(inputs)
	if (locale === "de") return de_feature_animation_triple_coin_title(inputs)
	if (locale === "es") return es_feature_animation_triple_coin_title(inputs)
	if (locale === "fr") return fr_feature_animation_triple_coin_title(inputs)
	if (locale === "it") return it_feature_animation_triple_coin_title(inputs)
	if (locale === "ja") return ja_feature_animation_triple_coin_title(inputs)
	if (locale === "ko") return ko_feature_animation_triple_coin_title(inputs)
	if (locale === "pt_br") return pt_br_feature_animation_triple_coin_title(inputs)
	if (locale === "ru") return ru_feature_animation_triple_coin_title(inputs)
	if (locale === "th") return th_feature_animation_triple_coin_title(inputs)
	if (locale === "tr") return tr_feature_animation_triple_coin_title(inputs)
	if (locale === "zh_cn") return zh_cn_feature_animation_triple_coin_title(inputs)
	return zh_tw_feature_animation_triple_coin_title(inputs)
});